export default {
    menu: "Menú",
    close_menu: "Cerrar Menú",
    viewing_as: "Viendo como:",

    // Menu items
    pdv: "PDV",
    tasks: "Tareas",
    tasks_list: "Lista",
    tasks_boards: "Tableros",

    metrics: "Métricas",
    rfm_analysis: "Análisis RFM",
    sales: "Ventas",
    retention_cohort: "Retención y Cohorte",
    clients: "Clientes",
    messages: "Mensajes",
    quotations: "Presupuestos",

    forms: "Formularios",
    forms_manage: "Administrar Formularios",
    forms_answers: "Respuestas",

    contacts: "Contactos",
    contact_base: "Base de Contactos",
    coupons_list: "Lista de Cupones",
    segments: "Segmentos",
    inbox: "Respuestas",

    marketing_actions: "Acciones de Marketing",

    benefits_center: "Central de Beneficios",
    settings: "Configuración",
    users: "Usuarios",
    data_sets: "Conjunto de Datos",
    connections: "Conexiones",
    whatsapp_connections: "Conexiones de WhatsApp",
    credits: "Créditos",
    custom_events: "Eventos Personalizados",
    client_fields: "Campos del cliente",
    order_fields: "Campos del pedido",
    quotation_fields: "Campos del presupuesto",
    order_status: "Estado del pedido",
    quotation_status: "Estado del presupuesto",
    notification_schedule: "Horarios de Envío de Notificaciones",
    utm_auto: "UTM Automático",
    agent_authorizations: "Autorizaciones del agente",
    products: "Productos",
    files_gallery: "Galería de Archivos",
    client_base_management: "Gestión de la base de clientes",
    import_history: "Importar datos",

    establishments: "Establecimientos",
    list: "Lista",
    plans: "Planes",
    adoption_report: "Informe de Adopción",
    translations: "Traducciones",
    email: "Email",
    email_generator: "Generador de Correo Electrónico",

    my_account: "Mi Cuenta",
    hello: "Hola, {0}!",
    reset_password: "Restablecer Contraseña",
    my_profile: "Mi perfil",
    two_factor_auth: "Autenticación 2FA",
    logout: "Salir",

    support: "Soporte",
    navigate: "Navegar",
    close: "Cerrar",
    logo_alt: "Logo de Kevi",

    // Logout confirmation
    logout_title: "Salir",
    logout_message: "¿Desea continuar la acción y salir del sistema?",
    no: "No",
    yes: "Sí",
};
